import { t } from 'i18next';
import { useMutation } from 'react-query';

import {
  removeApprovedVendors,
  upsertApprovedVendors,
} from 'companySettings/services/approvedVendor';
import { NotificationPosition } from 'core/enums';
import { useHandleErrors } from 'core/hooks';

export const useApprovedVendorsActions = (
  position: NotificationPosition = NotificationPosition.FORM
) => {
  return {
    ...useUpsertApprovedVendors(position),
    ...useRemoveApprovedVendors(position),
  };
};

const useUpsertApprovedVendors = (position: NotificationPosition) => {
  const { errors } = useHandleErrors({
    success: () => ({
      message: t('messageApprovedVendorUpdateSuccess'),
    }),
    loading: () => ({
      message: t('messageApprovedVendorUpdateInProgress'),
    }),
    error: () => ({
      title: t('errorTitleApprovedVendorUpdate'),
    }),
    position,
  });

  const { mutateAsync } = useMutation(upsertApprovedVendors, {
    ...errors,
  });

  return { upsertApprovedVendors: mutateAsync };
};

const useRemoveApprovedVendors = (position: NotificationPosition) => {
  const { errors } = useHandleErrors({
    success: () => ({
      message: t('messageApprovedVendorRemoveSuccess'),
    }),
    loading: () => ({
      message: t('messageApprovedVendorRemoveInProgress'),
    }),
    error: () => ({
      title: t('errorTitleApprovedVendorRemove'),
    }),
    position,
  });

  const { mutateAsync } = useMutation(removeApprovedVendors, {
    ...errors,
  });

  return { removeApprovedVendors: mutateAsync };
};
